import { isEmpty } from 'ramda'
import { useChangeSearch, useFilter, useSearch } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import FiltersBar from './filters/FiltersBar'
import IconButton from '../../../components/actions/IconButton'
import ScreenDropdown from '../../../containers/screens/ScreenDropdown'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ControlBar = ({ selectedScreen, children }) => {
  const { t } = useTranslation()

  const hasFilter = !isEmpty(useFilter())
  const [isFiltering, setFiltering] = React.useState(hasFilter)
  const hideFilter = () => setFiltering(false)
  const toggleFilter = () => setFiltering(!hasFilter ? !isFiltering : true)

  const changeSearch = useChangeSearch()
  const search = useSearch()

  return (
    <>
      <Separator weight={4} />
      <Grid justify="space-between" gutter={0.4}>
        <Col>
          <ScreenDropdown selected={selectedScreen} screen="integrations" />
        </Col>

        <Col />

        <Col>{children}</Col>

        <Col flex={3} />
        <Col flex={1}>
          <SearchInput value={search} onStopTyping={changeSearch} />
        </Col>
      </Grid>
      <Separator weight={4} />
    </>
  )
}

export default ControlBar
